import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'

// API
import * as API from '../../../../utils/api';

// Components
import FormContainer from '../../../../components/Global/FormContainer';
import LockerContactForm from './LockerContactForm/LockerContactForm';

// Flash Message Component
import FlashMessage from '../../../../components/Global/FlashMessage';

class LockerContact extends Component {
  static propTypes = {
    participation: PropTypes.object
  }

  state ={
    isLoading: true,
    flashMessage: {
      type: '',
      message: '',
    },
    displayFlashMessage: false,
  }

  componentWillReceiveProps(nextProps) {
    nextProps.participation && this.setState({isLoading: false})
  }

  handleSubmit = (values) => {
    const { user, participation } = this.props

    API.updateParticipation(user, participation, values)
    .then(response => {
      window.scrollTo(0, 0)
      if (response.status === 200) {
        this.setFlashMessage('', 'Changes saved successfully', true)
      } else {
        this.setFlashMessage('error', `Error: ${response.message}`, true)
      }
    })
  }

  setFlashMessage = (type, message, display) => {
    this.setState({
      flashMessage: {
        type,
        message
      },
      displayFlashMessage: display
    })
  }

  renderFlashMessage() {
    const {
      displayFlashMessage,
      flashMessage
    } = this.state;

    return displayFlashMessage
    ? (
      <FlashMessage optionalClasses={flashMessage.type === 'error' ? 'error' : ''}>
        {flashMessage.message}
      </FlashMessage>
    ) : null
  }

  render() {
    if (this.state.isLoading) return(null)

    const { school } = this.props.participation.contacts
    const { participation } = this.props
    const { trial_active, on_trial } = this.props.activeProfile.trial_info
    const isLocked = on_trial && !trial_active

    return (
      <FormContainer optionalClassName="locker-contact" isLocked={isLocked}>
        {this.renderFlashMessage()}
        <header>
          <h2>Contact</h2>
        </header>
        <p className="locker-contact-school-info">
          <span className="school-name">
            {school.school_name}
          </span>
          <br/>
          {school.address}
          <br/>
          {`${school.city} ${school.state}, ${school.zip}`}
          <br/>
          {school.phone}
        </p>
        <LockerContactForm
          onSubmit={this.handleSubmit}
          participation={participation}
        />
      </FormContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile
  }
}

// const mapDispatchToProps = dispatch => {
//   return {
//     getProfileAccountDetails: (user, athleteUsername) => {
//       dispatch(getProfileAccountDetails(user, athleteUsername))
//     },
//   }
// }

export default connect(
  mapStateToProps,
  null
)(LockerContact)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerContact.js